import BigNumber from 'bignumber.js'

BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 80
})
export const getSimpleStakeToysEarnGatAddress = sushi => {
  return (
    sushi &&
    sushi.contracts &&
    sushi.contracts.simpleStakeToysEarnGat &&
    sushi.contracts.simpleStakeToysEarnGat.options.address
  )
}
export const getSimpleStakeToysEarnGatContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.simpleStakeToysEarnGat
}

export const simpleStakeERC721EarnERC20Stake = async (simpleStakeERC721EarnERC20, tokenId, account) => {
  return simpleStakeERC721EarnERC20.methods
    .stake(tokenId)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(`simpleStakeERC721EarnERC20Stake ${tx}`)
      return tx.transactionHash
    })
}

export const simpleStakeERC721EarnERC20BatchStake = async (simpleStakeERC721EarnERC20, tokenIds, account) => {
  return simpleStakeERC721EarnERC20.methods
    .batchStake(tokenIds)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(`simpleStakeERC721EarnERC20BatchStake ${tx}`)
      return tx.transactionHash
    })
}

export const simpleStakeERC721EarnERC20Unstake = async (simpleStakeERC721EarnERC20, tokenId, account) => {
  return simpleStakeERC721EarnERC20.methods
    .unstake(tokenId)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(`simpleStakeERC721EarnERC20Unstake ${tx}`)
      return tx.transactionHash
    })
}

export const simpleStakeERC721EarnERC20BatchUnstake = async (simpleStakeERC721EarnERC20, tokenIds, account) => {
  return simpleStakeERC721EarnERC20.methods
    .batchUnstake(tokenIds)
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(`simpleStakeERC721EarnERC20BatchUnstake ${tx}`)
      return tx.transactionHash
    })
}

export const simpleStakeERC721EarnERC20Harvest = async (simpleStakeERC721EarnERC20, account) => {
  return simpleStakeERC721EarnERC20.methods
    .harvest()
    .send({ from: account })
    .on('transactionHash', tx => {
      console.log(`simpleStakeERC721EarnERC20Harvest ${tx}`)
      return tx.transactionHash
    })
}

/**
 * 返回当前池子stake的nft 所有stakingPower, 已经收割的量, stake中的tokenId
 * @param simpleStakeERC721EarnERC20
 * @param account
 * @returns {Promise<[stakingPower, rewardDebt, tokenIds]>}
 */
export const simpleStakeERC721EarnERC20GetUserInfo = async (simpleStakeERC721EarnERC20, account) => {
  return await simpleStakeERC721EarnERC20.methods.getUserInfo(account).call()
}

/**
 * 返回待收割数量
 * @param simpleStakeERC721EarnERC20
 * @param account
 * @returns {Promise<*>}
 */
export const simpleStakeERC721EarnERC20PendingToken = async (simpleStakeERC721EarnERC20, account) => {
  return simpleStakeERC721EarnERC20.methods.pendingToken(account).call()
}

/**
 * 返回是否可以抵押
 * @param simpleStakeERC721EarnERC20
 * @param tokenIds
 * @returns {Promise<*>}
 */
export const simpleStakeERC721EarnERC20CanStake = async (simpleStakeERC721EarnERC20, tokenIds) => {
  return simpleStakeERC721EarnERC20.methods.canStake(tokenIds).call()
}
